import React from "react";
import refresh from "../../../assets/images/generic/refresh.svg";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
const RefreshLabel = (props) => {
    const device = DeviceContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `refreshOuterDiv ${props.parentClassName}` }, props.icon ? (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.mobRefresh) ? (React.createElement("div", { onClick: () => {
                props.onCallBackFunction && props.onCallBackFunction();
            }, className: "hand_cursor image text-center px-1" },
            React.createElement("img", { src: refresh }),
            React.createElement("p", { className: "DMSan_14_500 txt_primaryGrey text pt-1 " }, props.title))) : (React.createElement("span", { onClick: () => {
                props.onCallBackFunction && props.onCallBackFunction();
            }, className: "hand_cursor image" },
            React.createElement("img", { src: refresh }),
            React.createElement("span", { className: "DMSan_14_500 txt_primaryGrey text ps-2 lineHeightmb30" }, props.title))))) : (React.createElement("span", { className: "DMSan_14_500 txt_primaryGrey text ps-0 mb-2" }, props.title)))));
};
export default RefreshLabel;
